import Constants from '../../utils/Constants';
import { NewPdnShortcut, ShortcutProps } from './Utils';

export const NewPdnActuator = () => {
  const props: ShortcutProps = {
    projectNameKey: 'NewActuatorProject',
    systemNameKey: 'NewActuatorSystem',
    systemTypeUniqueId: Constants.systemTypes.pdn.multiPart,
    autoExecAction: Constants.autoExecActions.launchSizingTool,
    groupUniqueName: Constants.groupsDefinitions.pdn.application,
    partCategoryName: Constants.partCategories.pdn.actuator,
  };

  return NewPdnShortcut(props);
};
